export class ArrayUtility {
    static removeItem(array, itemOrPredicate) {
        let ix;
        if (typeof (itemOrPredicate) === 'function') {
            ix = array.findIndex(itemOrPredicate);
        }
        else {
            ix = array.indexOf(itemOrPredicate);
        }
        if (ix > -1) {
            array.splice(ix, 1);
        }
        return ix;
    }
    static removeItems(array, predicate) {
        if (!array.length)
            return [];
        const indices = [];
        const removed = [];
        // Create a reverse array of indices, then remove them in that order.
        for (let i = array.length - 1; i > -1; i--) {
            if (predicate(array[i])) {
                indices.push(i);
                removed.push(array[i]);
            }
        }
        indices.forEach(i => {
            array.splice(i, 1);
        });
        return removed;
    }
    /**
     * Moves the element at the specified position to a new position in the array
     * @param array The target array.
     * @param currentIndex The element's current index.
     * @param afterIndex The index position of the element after which the element must be moved. The value can be -1
     * if the item must be moved to the start of the array.
     * @returns The element's previous index.
     */
    static moveAfter(array, currentIndex, afterIndex) {
        if (currentIndex > array.length - 1) {
            throw 'Cannot move item in the array because the index is out of range.';
        }
        return this.moveItemAfter(array, array[currentIndex], afterIndex);
    }
    /**
    * Moves the specified element to a new place in the array.
    * @param array The target array.
    * @param element The element to move.
    * @param afterIndex The index position of the element after which the element must be moved.
    * @returns The element's previous index.
    */
    static moveItemAfter(array, element, afterIndex) {
        const currentIndex = array.indexOf(element);
        if (currentIndex === -1) {
            throw 'Cannot move item in the array because it does not exist.';
        }
        if (afterIndex === currentIndex) {
            return { newIndex: currentIndex, restoreAfterIndex: currentIndex, hasChanged: false };
        }
        // First remove the element
        array.splice(currentIndex, 1);
        // Then insert it at the new index.
        let newIndex;
        let restoreAfter = 0;
        if (afterIndex > currentIndex) {
            // The removed item was before the new index, take that into account.
            newIndex = afterIndex;
            restoreAfter = currentIndex - 1;
        }
        else {
            newIndex = afterIndex + 1;
            restoreAfter = currentIndex;
        }
        array.splice(newIndex, 0, element);
        return { newIndex: newIndex, restoreAfterIndex: restoreAfter, hasChanged: true };
    }
    static findOtherIndex(array, current, other) {
        return array.findIndex(item => item !== current && other(item));
    }
    static findLastIndex(array, predicate) {
        let l = array.length;
        while (l--) {
            if (predicate(array[l]))
                return l;
        }
        return -1;
    }
    static findLast(array, predicate) {
        let l = array.length;
        while (l--) {
            if (predicate(array[l]))
                return array[l];
        }
    }
    static count(array, predicate) {
        if (!array || !array.length)
            return 0;
        let result = 0;
        array.forEach(item => {
            if (predicate(item))
                result++;
        });
        return result;
    }
    static fromObject(obj, ...useKeys) {
        const result = [];
        const keys = useKeys.length ? useKeys : Object.keys(obj);
        keys.forEach(k => {
            const item = obj[k];
            if (item)
                result.push(item);
            else
                console.warn(`Object key '${k}' not found (no array item can be created).`);
        });
        return result;
    }
    /**
    * Returns all elements that are in array A but not in array B.
    */
    static difference(arrayA, arrayB) {
        const diff = [];
        for (let i = 0; i < arrayA.length; i++) {
            if (arrayB.indexOf(arrayA[i]) === -1) {
                diff.push(arrayA[i]);
            }
        }
        return diff;
    }
}
//# sourceMappingURL=array-utility.js.map